import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area'
import { type ComponentPropsWithoutRef, type CSSProperties, type ElementRef, forwardRef } from 'react'
import { cn } from '@shared/utils'

export const ScrollArea = forwardRef<
  ElementRef<typeof ScrollAreaPrimitive.Root>,
  // thumbClassName: nền tối (sidebar) cần màu thanh cuộn riêng, `bg-border` gần như không thấy
  // viewportClassName: khung cao theo nội dung (vd danh sách `max-h-72`) phải giới hạn ở Viewport — đặt ở Root thì Viewport `h-full` không cuộn
  // scrollbars: bảng rộng (vd bảng nhập liệu trong form hồ sơ) cần thanh cuộn ngang; mặc định chỉ dọc như trước
  ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root> & {
    thumbClassName?: string
    viewportClassName?: string
    /** giới hạn cao tính lúc chạy (vd lưới Excel nhận chiều cao qua prop) – lớp Tailwind không viết được */
    viewportStyle?: CSSProperties
    scrollbars?: 'vertical' | 'horizontal' | 'both'
  }
>(
  (
    { className, thumbClassName, viewportClassName, viewportStyle, scrollbars = 'vertical', children, ...props },
    ref,
  ) => (
    <ScrollAreaPrimitive.Root
      ref={ref}
      className={cn('relative overflow-hidden', className)}
      {...props}
    >
      <ScrollAreaPrimitive.Viewport
        className={cn('h-full w-full rounded-[inherit]', viewportClassName)}
        style={viewportStyle}
      >
        {children}
      </ScrollAreaPrimitive.Viewport>
      {scrollbars !== 'horizontal' && <ScrollBar thumbClassName={thumbClassName} />}
      {scrollbars !== 'vertical' && (
        <ScrollBar orientation="horizontal" thumbClassName={thumbClassName} />
      )}
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  ),
)
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName

export const ScrollBar = forwardRef<
  ElementRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>,
  ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar> & {
    thumbClassName?: string
  }
>(({ className, thumbClassName, orientation = 'vertical', ...props }, ref) => (
  <ScrollAreaPrimitive.ScrollAreaScrollbar
    ref={ref}
    orientation={orientation}
    className={cn(
      'flex touch-none select-none transition-colors',
      orientation === 'vertical' && 'h-full w-2.5 border-l border-l-transparent p-[1px]',
      orientation === 'horizontal' && 'h-2.5 flex-col border-t border-t-transparent p-[1px]',
      className,
    )}
    {...props}
  >
    <ScrollAreaPrimitive.ScrollAreaThumb
      className={cn('relative flex-1 rounded-full bg-border', thumbClassName)}
    />
  </ScrollAreaPrimitive.ScrollAreaScrollbar>
))
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName
